<template>
  <el-dialog
    title="維養登記表單 QRCode"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <!-- ref: 現場訪客登記表單 QR Code -->
    <div class="QRCode-container">
      <vue-qr
        :correct-level="0"
        :dot-scale="1"
        :text="`${selectSupplier}`"
        :logo-background-color="'#fff'"
        :logo-margin="0"
        :logo-scale="0.3"
        :logo-corner-radius="20"
        :size="500"
      />
    </div>
    <div class="button-container">
      <el-button
        type="primary"
        @click="dialogVisible = false"
      >
        關閉
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      isLoading: false,
      selectSupplier: null
    }
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    async genQRCodeBySupplierId (supplierId) {
      try {
        const res = await apiAsset.maintenance.getSupplierLoginToken(supplierId)
        this.dialogVisible = true
        const token = res.data.Token
        const urlSegment1 = (process.env.NODE_ENV === 'development') ? window.location.origin : window.location.origin + '/mgmt'
        const qrCodeLink = `${urlSegment1}/supplierMaintenance/login?jwt=${token}`
        this.selectSupplier = qrCodeLink
        console.log('qrCodeLink', qrCodeLink)
      } catch (error) {
        this.$message.error('發生未知錯誤，請稍後再試')
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .subtitle {
      align-self: start;
    }
    .QRCode-container {
      img {
        width: 250px;
        height: 250px;
      }
    }
  }
}
</style>
